import { object } from '@iwentsourcing/core/typing/object.js';
import { string } from '@iwentsourcing/core/typing/string.js';
import { TypeOf } from '@iwentsourcing/core/typing/type-of.js';

export const OAuthTransferStateData = object('OAuthTransferStateData', {
  redirectUri: string(),
  provider: string(),
  tenant: string(),
  realm: string(),
});
export type OAuthTransferStateData = TypeOf<typeof OAuthTransferStateData>;
